export default __webpack_public_path__ + "static/media/ebs-decor.98e2fbb8.png";